/**
 * ENIGMA Parfume — Shopify Theme JS v4
 * Event delegation for FAQ/Pyramid + IntersectionObserver for animations
 * Upload to: Shopify > Themes > Edit Code > Assets > enigma.js
 */
(function () {
  'use strict'
  window.ENIGMA = true

  // ─── Helper: run after DOM ready ─────────────────────
  function onReady(fn) {
    if (document.readyState !== 'loading') { fn() }
    else { document.addEventListener('DOMContentLoaded', fn) }
  }

  // ─── FAQ Accordion (Event Delegation — works regardless of load order) ───
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.e-faq__trigger, .e-faq__q')
    if (!btn) return

    var item = btn.closest('.e-faq__item')
    if (!item) return
    var isOpen = item.classList.contains('open')

    // Close all FAQ items
    document.querySelectorAll('.e-faq__item.open').forEach(function (openItem) {
      openItem.classList.remove('open')
      var answer = openItem.querySelector('.e-faq__answer, .e-faq__a')
      if (answer) answer.setAttribute('hidden', '')
      var trigger = openItem.querySelector('.e-faq__trigger, .e-faq__q')
      if (trigger) trigger.setAttribute('aria-expanded', 'false')
    })

    // Toggle clicked item
    if (!isOpen) {
      item.classList.add('open')
      var answer = item.querySelector('.e-faq__answer, .e-faq__a')
      if (answer) answer.removeAttribute('hidden')
      btn.setAttribute('aria-expanded', 'true')
    }
  })

  // ─── Pyramid Accordion (Event Delegation) ─────────────
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.e-pyramid__toggle')
    if (!btn) return

    var tier = btn.closest('.e-pyramid__tier')
    if (!tier) return
    var isOpen = tier.classList.contains('open')

    // Close all
    document.querySelectorAll('.e-pyramid__tier.open').forEach(function (t) {
      t.classList.remove('open')
    })

    // Toggle clicked
    if (!isOpen) tier.classList.add('open')
  })

  // ─── Scroll Reveal (IntersectionObserver) ─────────
  onReady(function () {
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('in-view')
            observer.unobserve(entry.target)
          }
        })
      }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' })

      document.querySelectorAll('.e-fade-in').forEach(function (el) {
        observer.observe(el)
      })

      // Re-observe after Shopify section rendering
      if (window.Shopify && window.Shopify.designMode) {
        document.addEventListener('shopify:section:load', function () {
          document.querySelectorAll('.e-fade-in:not(.in-view)').forEach(function (el) {
            observer.observe(el)
          })
        })
      }
    } else {
      document.querySelectorAll('.e-fade-in').forEach(function (el) {
        el.classList.add('in-view')
      })
    }

    // ─── Scent Profile Donut Animation ─────────────────
    function animateDonut(donutEl) {
      var segments = donutEl.querySelectorAll('.e-donut__segment')
      if (!segments.length) return
      var offset = 0
      segments.forEach(function (seg) {
        var pct = parseFloat(seg.getAttribute('data-percent') || '0')
        var circumference = 2 * Math.PI * 42
        var dashLen = (pct / 100) * circumference
        seg.style.strokeDasharray = dashLen + ' ' + circumference
        seg.style.strokeDashoffset = '-' + offset
        offset += dashLen
      })
    }

    document.querySelectorAll('.e-donut').forEach(function (donut) {
      if ('IntersectionObserver' in window) {
        var donutObs = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              animateDonut(entry.target)
              donutObs.unobserve(entry.target)
            }
          })
        }, { threshold: 0.3 })
        donutObs.observe(donut)
      } else {
        animateDonut(donut)
      }
    })
  })
})()
